import {FileCard} from "../../../../../core/types/file-card.types";
import {defaultFileParams} from "../../../../../core/models/default-file-params";
import {ImgSize} from "../types/file-card.types";

export const defaultFileCard: FileCard = {
  id: 0,
  fileParams: defaultFileParams,
  isEditModeActive: false,
  shouldCheckImageType: false
}

export const defaultImgSize: ImgSize = {
  height: '80px',
  width: '80px'
}
